import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Security utilities for input validation and sanitization
export function sanitizeInput(input: string): string {
  // Remove HTML tags and script content for XSS protection
  return input
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim();
}

export function validateTodoInput(title: string): { isValid: boolean; error?: string } {
  const sanitized = sanitizeInput(title);
  
  if (!sanitized || sanitized.length === 0) {
    return { isValid: false, error: "Todo title cannot be empty" };
  }
  
  if (sanitized.length > 200) {
    return { isValid: false, error: "Todo title must be less than 200 characters" };
  }
  
  // Check for suspicious patterns
  const suspiciousPatterns = [
    /javascript:/i,
    /data:/i,
    /vbscript:/i,
    /on\w+\s*=/i
  ];
  
  if (suspiciousPatterns.some(pattern => pattern.test(sanitized))) {
    return { isValid: false, error: "Invalid characters detected" };
  }
  
  return { isValid: true };
}

export function validatePaymentAmount(amount: number): { isValid: boolean; error?: string } {
  if (!Number.isFinite(amount) || amount <= 0) {
    return { isValid: false, error: "Invalid payment amount" };
  }
  
  if (amount > 100) {
    return { isValid: false, error: "Payment amount cannot exceed $100" };
  }
  
  if (amount < 3.00) {
    return { isValid: false, error: "Payment amount must be at least $3.00" };
  }
  
  return { isValid: true };
}
